import React from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import HeroContent from './HeroContent';

const Hero = () => {
  const circles = [
    { 
      icon: '/assets/icons/hero-1.svg',
      className: 'absolute top-[30%] left-24',
      circleSize: 'w-40 h-40',
      iconSize: 'w-28 h-28',
      iconStyle: 'bg-white rounded-full p-1',
      animate: {
        y: [-10, 10],
      }
    },
    { 
      icon: '/assets/icons/hero-2.svg',
      className: 'absolute top-[30%] right-24',
      circleSize: 'w-36 h-36',
      iconSize: 'w-20 h-20',
      animate: {
        y: [10, -10],
      }
    },
    { 
      icon: '/assets/icons/hero-3.svg',
      className: 'absolute bottom-[20%] left-24',
      circleSize: 'w-36 h-36',
      iconSize: 'w-24 h-24',
      animate: {
        y: [-8, 8],
      }
    },
    { 
      icon: '/assets/icons/hero-4.svg',
      className: 'absolute bottom-[20%] right-24',
      circleSize: 'w-36 h-36',
      iconSize: 'w-30 h-30',
      animate: {
        y: [8, -8],
      }
    }
  ];

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* Background principal - ajusté pour commencer sous le header */}
      <div 
        className="absolute top-[140px] bottom-0 left-0 right-0 bg-center bg-no-repeat "
        style={{
          backgroundImage: `url('/assets/icons/bg.png')`
        }}
      />

  


      <Header />
      <div className="absolute inset-0 flex items-center justify-center mt-32">
        <HeroContent />
      </div>
      
      {/* Floating Circles */}
      {circles.map((circle, index) => (
        <motion.div 
          key={index} 
          className={`${circle.className} ${circle.circleSize} rounded-full bg-white bg-opacity-10 flex items-center justify-center hidden md:flex`}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ 
            opacity: 1, 
            scale: 1,
            ...circle.animate
          }}
          transition={{
            y: {
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut",
            },
            opacity: { duration: 0.5 },
            scale: { duration: 0.5 }
          }}
        >
          <img 
            src={circle.icon} 
            alt="service icon" 
            className={`${circle.iconSize} ${circle.iconStyle || ''}`}
          />
          
          {/* Glowing border effect */}
          <motion.div
            className="absolute inset-0 rounded-full border border-white opacity-20"
            animate={{
              scale: [1, 1.05, 1],
              opacity: [0.2, 0.3, 0.2],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut",
            }}
          />
        </motion.div>
      ))}

      {/* Connecting Lines */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none">
        <motion.path
          d="M0 0"  // This will be calculated based on circle positions
          stroke="rgba(255, 255, 255, 0.1)"
          strokeWidth="1"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 2,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
      </svg>
    </section>
  );
};

export default Hero;